export default __webpack_public_path__ + "6e04fbebc74acf872823611bdb244481.jpg";